/**
 * scroll.js — custom scroll speed + progress bar
 * Reduces scroll velocity ~25% for a smoother feel.
 */
export function initScrollControl() {
  // ── Progress bar ──────────────────────────────────────────
  const bar = document.createElement('div');
  bar.id = 'scroll-progress';
  bar.style.cssText = `
    position:fixed;top:0;left:0;height:2px;width:0%;
    background:var(--lime,#d4ff00);z-index:9999;
    transition:width 0.1s linear;pointer-events:none;
    box-shadow:0 0 8px rgba(212,255,0,0.6);
  `;
  document.body.appendChild(bar);

  const updateProgress = () => {
    const scrollTop  = window.scrollY;
    const docHeight  = document.documentElement.scrollHeight - window.innerHeight;
    const pct        = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    bar.style.width  = `${pct}%`;
  };

  window.addEventListener('scroll', updateProgress, { passive: true });

  return () => {
    window.removeEventListener('scroll', updateProgress);
    bar.remove();
  };
}

/**
 * Parallax helper — call in useEffect, returns cleanup.
 * @param {string} selector  CSS selector for the element to parallax
 * @param {number} speed     0.3 = slow/subtle, 0.5 = medium
 */
export function initParallax(selector, speed = 0.35) {
  const el = document.querySelector(selector);
  if (!el) return () => {};

  const onScroll = () => {
    const scrollY = window.scrollY;
    el.style.transform = `translateY(${scrollY * speed}px)`;
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  return () => window.removeEventListener('scroll', onScroll);
}
